"use client";
import ArrowGradient from "@/commonComponents/arrow-gradient";
import { MotionTypography } from "@/commonComponents/motion-components";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { H6_2 } from "@/styles/theme/components/typography.fontvariant";
import { Box, Grid, Stack } from "@mui/material";
import { useState } from "react";
import InitiativeHeroCard from "@c/ourCompanies/heroesOfInitiatives/initiative-hero-card";
import {
  arrowLeftToRightTransition,
  bottomToToptextTransition,
} from "@/commonComponents/animations";
import GalleryDialog, {
  LeaderSlideProps,
} from "@/commonComponents/gallery-dialog";
import { SetRequired } from "type-fest";

export type LeadershipProps = {
  data: {
    title: string;
    leadersData: SetRequired<LeaderSlideProps, "title">[];
  };
};

const Leadership = (props: LeadershipProps) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setactiveIndex] = useState(0);

  const { title, leadersData } = props.data;
  return (
    <SectionWrapper
      SectionProps={{
        bgcolor: "primary.main",
        id: "leadership",
      }}
      ContainerProps={{ pt: "30px !important" }}
      navId="leadership"
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        columnGap={1}
        mb={{ xs: 4, md: 2 }}
      >
        <ArrowGradient
          SVGProps={{
            width: 73,
            height: 191,
          }}
          display={{ xs: "none", md: "block" }}
          {...arrowLeftToRightTransition}
        />
        <MotionTypography
          component={"p"}
          variant="h1"
          variants={bottomToToptextTransition(0)}
          initial="initial"
          whileInView={"animate"}
          viewport={{ once: true }}
        >
          {title}
        </MotionTypography>
      </Stack>
      <Box width={1}>
        <Grid
          container
          rowSpacing={{ xs: 2, md: 3 }}
          columnSpacing={{ xs: 2, md: 3 }}
          // justifyContent={"space-between"}
          width={1}
        >
          {leadersData.map((item, idx) => (
            <Grid
              item
              key={idx}
              xs={6}
              md={4}
              // maxWidth={421}
              minHeight={{ xs: 234, md: "auto" }}
            >
              <InitiativeHeroCard
                isActive
                data={item}
                sx={{
                  width: "100% !important",
                  height: "100%",
                  minWidth: "100%",
                  backgroundPosition: "center",
                }}
                TitleTypographyProps={{
                  sx: {
                    textTransform: "capitalize",
                    fontSize: H6_2,
                  },
                }}
                ContentWrapperSxProps={{
                  p: 1.5,
                }}
                onClick={() => {
                  setOpen(true);
                  setactiveIndex(idx);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <GalleryDialog
        open={open}
        setOpen={setOpen}
        data={leadersData}
        activeIndex={activeIndex}
      />
    </SectionWrapper>
  );
};

export default Leadership;
